import { IColumn } from "../../../models";

export const insurance: IColumn = {
  A: {
    key: "insurance_id",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: " Insurance Type Id",
  },
  B: {
    key: "insurance_name",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: " Insurance Type Name",
  },
};
